/**
 * NormalizationBanner — Shows auto-correction info when the backend
 * normalizes the user's query (spell correction / synonym resolution).
 */
import React, { useState } from 'react'

export function NormalizationBanner({ normalization }) {
  const [expanded, setExpanded] = useState(false)

  if (!normalization || !normalization.was_modified) return null

  const { original_query, corrected_query, replacements = [] } = normalization

  return (
    <div className="rounded-2xl border border-blue-100 bg-blue-50/60 px-4 py-3">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-2 text-sm text-blue-800">
            <span className="text-base">🔄</span>
            <span className="font-medium">Auto-corrected:</span>
            <span className="text-blue-600 line-through decoration-blue-300">{original_query}</span>
            <span className="text-blue-500">→</span>
            <span className="font-semibold text-blue-900">{corrected_query}</span>
          </div>
          {expanded && replacements.length > 0 && (
            <div className="mt-2 flex flex-wrap gap-2">
              {replacements.map((r, i) => (
                <span
                  key={i}
                  className="inline-flex items-center gap-1.5 rounded-full border border-blue-200 bg-white px-2.5 py-1 text-xs"
                >
                  <span className="text-blue-600 line-through">{r.original}</span>
                  <span className="text-blue-400">→</span>
                  <span className="font-medium text-blue-900">{r.canonical}</span>
                  <span className="text-blue-400">
                    ({r.match_type}{r.confidence < 1 ? `, ${Math.round(r.confidence * 100)}%` : ''})
                  </span>
                </span>
              ))}
            </div>
          )}
        </div>
        {replacements.length > 0 && (
          <button
            onClick={() => setExpanded((v) => !v)}
            className="flex-shrink-0 rounded-lg px-2 py-1 text-xs font-medium text-blue-600 transition hover:bg-blue-100"
          >
            {expanded ? 'Less' : 'Details'}
          </button>
        )}
      </div>
    </div>
  )
}
